module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog,
      "custom-class": "view-content"
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "view-content-body"
  }, [_c('pre', [_vm._v(_vm._s(_vm.content))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-714d5c88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/viewContentDialog.vue
// module id = 1420
// module chunks = 1